import type { EmployeeRole } from "./types";

export const ROLE_META: Record<EmployeeRole, { label: string; badgeCls: string }> = {
  bartender:  { label: "Bartender",  badgeCls: "bg-blue-500/15 text-blue-300" },
  axe_coach:  { label: "Axe Coach",  badgeCls: "bg-amber-500/15 text-amber-300" },
  kitchen:    { label: "Kitchen",    badgeCls: "bg-emerald-500/15 text-emerald-300" },
  front_desk: { label: "Front Desk", badgeCls: "bg-purple-500/15 text-purple-300" },
};

export const ROLE_ORDER: EmployeeRole[] = ["bartender", "axe_coach", "front_desk", "kitchen"];
